import { takeEvery, put, call, all, SelectEffect, CallEffect } from 'redux-saga/effects';
import { LoginAndRegisterActionType, LogoutAllUnits } from '../../actions/loginAndRegisterActions';
import { RequestActionType, requestError, requestSuccess } from '../../actions/requestActions';
import logoutAllUnits from '../../api/logoutAllUnits';
import { pathsOutsideLogin } from '../../constants';
import RequestActions from '../../models/RequestTypes';
import { RequestType } from '../../reducers/requestReducer';
import { toErrorType } from '../isErrorType';
import { redirectWithQuery } from './loginSaga';

export const clearStorage = (): void => {
    const language = localStorage.getItem('i18nextLng');
    localStorage.clear();
    if (language) localStorage.setItem('i18nextLng', language);
};

export const redirectToLogin = (): void => {
    if (!pathsOutsideLogin.includes(window.location.pathname)) {
        redirectWithQuery('/login');
    }
};

type LogoutSaga = Generator<SelectEffect | CallEffect<void> | RequestActions, void, boolean>;
export function* logoutSaga(): LogoutSaga {
    try {
        clearStorage();
        yield put(requestSuccess(RequestType.LogOut, RequestActionType.Success));
        yield call(redirectToLogin);
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(requestError(errorAsErrorType, RequestType.LogOut, RequestActionType.Error));
    }
}

type LogOutAllUnitsSaga = Generator<CallEffect<void> | RequestActions, void, void>;
export function* logoutAllUnitsSaga({ email }: LogoutAllUnits): LogOutAllUnitsSaga {
    try {
        yield call(logoutAllUnits, email);
        clearStorage();
        yield put(requestSuccess(RequestType.LogOutAllUnits, RequestActionType.Success));
        yield call(redirectToLogin);
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(requestError(errorAsErrorType, RequestType.LogOutAllUnits, RequestActionType.Error));
    }
}

export default function* (): Generator {
    yield all([
        takeEvery(LoginAndRegisterActionType.LogOutAllUnitsInit, logoutAllUnitsSaga),
        takeEvery(LoginAndRegisterActionType.LogOutInit, logoutSaga),
    ]);
}
